var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson64({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7986 18.4418C22.3822 19.3882 20.7169 19.8934 19.0133 19.8934C16.7289 19.8934 14.5381 18.9859 12.9228 17.3706C11.3075 15.7553 10.4 13.5645 10.4 11.2801C10.4 9.57653 10.9052 7.91122 11.8516 6.49477C12.798 5.07831 14.1432 3.97433 15.7171 3.32241C17.291 2.67048 19.0229 2.49991 20.6937 2.83225C22.3645 3.1646 23.8993 3.98492 25.1039 5.18951C26.3085 6.39411 27.1288 7.92885 27.4611 9.59967C27.7935 11.2705 27.6229 13.0023 26.971 14.5762C26.3191 16.1501 25.2151 17.4953 23.7986 18.4418Z",
    stroke: "#D1D5DB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 38.4801C2 31.2534 8.98664 26.2134 19.0133 26.2134C29.04 26.2134 36.0267 31.2534 36.0267 38.4801C36.0253 38.7918 35.9436 39.0979 35.7894 39.3688C35.6353 39.6397 35.4139 39.8663 35.1466 40.0268C34.9333 40.1334 30 42.9867 18.56 42.9867C7.51998 42.9867 3.22665 40.2667 2.77332 39.9734C2.53657 39.8023 2.34326 39.5781 2.20894 39.3188C2.07463 39.0594 2.00308 38.7721 2 38.4801Z",
    stroke: "#D1D5DB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson64);
export default __webpack_public_path__ + "static/media/icon-person-64.07274c4fa085c139ea5067c44ff6de29.svg";
export { ForwardRef as ReactComponent };